import { render } from "./OnlineBankTransfer.vue?vue&type=template&id=f3f251e8&scoped=true"
import script from "./OnlineBankTransfer.vue?vue&type=script&lang=js"
export * from "./OnlineBankTransfer.vue?vue&type=script&lang=js"

import "./OnlineBankTransfer.vue?vue&type=style&index=0&id=f3f251e8&lang=less&scoped=true"
import "./OnlineBankTransfer.vue?vue&type=style&index=1&id=f3f251e8&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f251e8"]])

export default __exports__